// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5e9a6c19","513":"7d04272d","703":"659a1fc0","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};